import { render } from "./ChangeUserProfileComponent.vue?vue&type=template&id=7827a9a8"
import script from "./ChangeUserProfileComponent.vue?vue&type=script&lang=js"
export * from "./ChangeUserProfileComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__